import {get, set, del, clear} from './idb-keyval'

export interface WebStorageShape {
  get<T>(key: string): Promise<T>
  set<T>(key: string, value: T): Promise<void>
  remove(key: string): Promise<void>
  clear(): Promise<void>
}

export const WebStorage: WebStorageShape = {
  get<T>(key: string): Promise<T> {
    return get<T>(key)
  },

  set<T>(key: string, value: T): Promise<void> {
    return set(key, value)
  },

  remove(key: string): Promise<void> {
    return del(key)
  },

  clear(): Promise<void> {
    return clear()
  }
}
